import { cloneElement } from 'react';
const cloneWithProps = (element, props) => /*#__PURE__*/cloneElement(element, {
  ...(props || {})
});
export default cloneWithProps;
//# sourceMappingURL=cloneWithProps.js.map